import { render, staticRenderFns } from "./Control.vue?vue&type=template&id=b4775a54&"
import script from "./Control.vue?vue&type=script&lang=js&"
export * from "./Control.vue?vue&type=script&lang=js&"
import style0 from "./Control.vue?vue&type=style&index=0&id=b4775a54&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports